import DeviceDetailsPage from './device-details-page';

export default DeviceDetailsPage;